import React from 'react';
import PropTypes from 'prop-types';

const CloseNormal = ({ fill = '' }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="">
    <path
      d="M7.99145 6.98577L13.7256 1.28303C14.0005 1.0109 14.0005 0.570358 13.7256 0.29892C13.4513 0.0267877 13.0059 0.0267877 12.7317 0.29892L7.00255 5.9968L1.22037 0.213994C0.946157 -0.0609148 0.50076 -0.0609148 0.226545 0.213994C-0.0476694 0.489598 -0.0476694 0.935689 0.226545 1.2106L6.0045 6.98924L0.205661 12.756C-0.0685537 13.0282 -0.0685537 13.4687 0.205661 13.7401C0.479876 14.0123 0.925273 14.0123 1.19949 13.7401L6.9934 7.97821L12.7526 13.7381C13.0268 14.013 13.4722 14.013 13.7464 13.7381C14.0206 13.4624 14.0206 13.0164 13.7464 12.7414L7.99145 6.98577Z"
      fill={fill || 'black'}
    />
  </svg>
);

CloseNormal.propTypes = {
  fill: PropTypes.string,
};

export default CloseNormal;
